var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1702,
    height: 133,
    viewBox: "0 0 1702 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2411_1046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.23 2.38002L48.3 130.46H45.62L0.619995 2.38002L2.83999 1.27002L46.96 126.59L91.08 1.29002L93.23 2.38002Z",
    stroke: "#231815",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.57 130.46H225.97V1.87H228.57V130.46Z",
    stroke: "#231815",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.35 131.82H375.9V1.87H378.5V129.01H439.35V131.83V131.82Z",
    stroke: "#231815",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.69 131.82H556.24V1.87H558.84V129.01H619.69V131.83V131.82Z",
    stroke: "#231815",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163.83 130.46H1161.07L1084.77 6.48006V130.46H1082.17V1.87006L1085.02 1.81006L1161.23 125.8V1.87006H1163.83V130.46Z",
    stroke: "#231815",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.26 3.32H1484.95V130.46H1482.35V3.32H1444.12V0.5H1523.25V3.32H1523.26Z",
    stroke: "#231815",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701.41 131.82H1626.69V0.5H1701.41V3.32H1629.29V129.01H1701.41V131.83V131.82ZM1661.65 68.02V65.2H1701.41V68.02H1661.65Z",
    stroke: "#231815",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.49 0.5H769.22L814.63 129.86L812.41 130.98L768.35 5.71L724.23 130.98L722.01 129.87L767.49 0.5Z",
    stroke: "#231815",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1341.43 129.01H1265.12V1.87H1262.52V131.82H1344.18V1.87H1341.57L1341.43 129.01Z",
    stroke: "#231815",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2411_1046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1701.91,
    height: 132.32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d7cd22d37baeaea922b19cc9d77c303b.svg";
export { ForwardRef as ReactComponent };